<template>
  <div>
    
    <div v-if="model.status != 15">
      <!-- ShipperDocument -->
      <b-form-group
        :label="$t('tracking.cargo.shipperDocument')"
        label-for="ShipperDocument"
      >
        <b-form-input
          id="ShipperDocument"
          type="text"
          :placeholder="$t('tracking.cargo.shipperDocument')"
          v-model="model.shipperDocument"
          v-mask="'99.999.999/9999-99'"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['ShipperDocument']">
          {{ modelstate["ShipperDocument"][0] }}
        </span>
      </b-form-group>

      <!-- shipperName -->
      <b-form-group
        :label="$t('tracking.cargo.shipperName')"
        label-for="ShipperName"
      >
        <b-form-input
          id="ShipperName"
          type="text"
          :placeholder="$t('tracking.cargo.shipperName')"
          v-model="model.shipperName"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['ShipperName']">
          {{ modelstate["ShipperName"][0] }}
        </span>
      </b-form-group>

      <!-- ServiceTakerDocument -->
      <b-form-group
        :label="$t('tracking.cargo.serviceTakerDocument')"
        label-for="ServiceTakerDocument"
      >
        <b-form-input
          id="ServiceTakerDocument"
          type="text"
          :placeholder="$t('tracking.cargo.serviceTakerDocument')"
          v-model="model.serviceTakerDocument"
          v-mask="'99.999.999/9999-99'"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['ServiceTakerDocument']">
          {{ modelstate["ServiceTakerDocument"][0] }}
        </span>
      </b-form-group>

      <!-- ServiceTakerName -->
      <b-form-group
        :label="$t('tracking.cargo.serviceTakerName')"
        label-for="ServiceTakerName"
      >
        <b-form-input
          id="ServiceTakerName"
          type="text"
          :placeholder="$t('tracking.cargo.serviceTakerName')"
          v-model="model.serviceTakerName"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['ServiceTakerName']">
          {{ modelstate["ServiceTakerName"][0] }}
        </span>
      </b-form-group>

      <!-- LoadingCteNumber -->
      <b-form-group label="CT-e" label-for="LoadingCteNumber">
        <b-form-input
          id="LoadingCteNumber"
          type="text"
          placeholder="CT-e"
          v-model="model.loadingCteNumber"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['LoadingCteNumber']">
          {{ modelstate["LoadingCteNumber"][0] }}
        </span>
      </b-form-group>

      <!-- LoadingManifestNumber -->
      <b-form-group label="Manifesto" label-for="LoadingManifestNumber">
        <b-form-input
          id="LoadingManifestNumber"
          type="text"
          placeholder="Manifesto"
          v-model="model.loadingManifestNumber"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['LoadingManifestNumber']">
          {{ modelstate["LoadingManifestNumber"][0] }}
        </span>
      </b-form-group>

      <!-- LoadingContractNumber -->
      <b-form-group
        label="Número do contrato"
        label-for="LoadingContractNumber"
      >
        <b-form-input
          id="LoadingContractNumber"
          type="text"
          placeholder="Número do contrato"
          v-model="model.loadingContractNumber"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['LoadingContractNumber']">
          {{ modelstate["LoadingContractNumber"][0] }}
        </span>
      </b-form-group>

      <!-- LoadingCiotNumber -->
      <b-form-group label="CIOT" label-for="LoadingCiotNumber">
        <b-form-input
          id="LoadingCiotNumber"
          type="text"
          placeholder="CIOT"
          v-model="model.loadingCiotNumber"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['LoadingCiotNumber']">
          {{ modelstate["LoadingCiotNumber"][0] }}
        </span>
      </b-form-group>

      <!-- TransportStartDate -->
      <b-form-group
        label="Data de inicio de transporte"
        label-for="TransportStartDate"
      >
        <b-form-input
          id="TransportStartDate"
          type="date"
          placeholder="Data de inicio de transporte"
          v-model="model.transportStartDate"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['TransportStartDate']">
          {{ modelstate["TransportStartDate"][0] }}
        </span>
      </b-form-group>

      <!-- TransportStartHour -->
      <b-form-group
        label="Hora de inicio de transporte"
        label-for="TransportStartHour"
      >
        <b-form-input
          id="TransportStartHour"
          type="time"
          placeholder="Hora de inicio de transporte"
          v-model="model.transportStartHour"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['TransportStartHour']">
          {{ modelstate["TransportStartHour"][0] }}
        </span>
      </b-form-group>
    </div>

    <!-- <pre class="language-json"><code>{{ model  }}</code></pre> -->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "CargoCrudStatusWaitingDocuments",
  components: {
  },
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data: function () {
    return {
      
    };
  },
  created() {
   
  },
  computed: {},
  methods: {
    
  },
};
</script>
